export enum MetalPropertyName {
  Material = 'material',
  Form = 'form',
  AmountScrapBased = 'amount_scrap_based',
}

export enum MetalSpecialPropertyName {
  ScrapBased = 'scrap_based',
}

export enum MetalMaterial {
  Aluminum = 'Aluminum',
  Copper = 'Copper',
  Steel = 'Steel',
}

export enum Aluminum {
  Profile = 'Profile',
  Sheet = 'Sheet',
}
export enum Copper {
  Pipe = 'Pipe',
  Sheet = 'Sheet',
  Wire = 'Wire',
}
export enum Steel {
  FastenersAndFitting = 'Fasteners and fittings',
  LightWeightProfile = 'Light-weight profile',
  PipeStainless = 'Pipe, stainless',
  Rebar = 'Rebar',
  RebarStainless = 'Rebar, stainless',
  Sheet = 'Sheet',
  SheetStainless = 'Sheet, stainless',
  Structural = 'Structural',
  Wire = 'Wire',
}

export enum AluminumProfile {
  None = 'None',
  Percent100 = '100%',
}
export enum AluminumSheet {
  None = 'None',
}
export enum CopperPipe {
  Percent51 = '51%',
  Percent100 = '100%',
}
export enum CopperSheet {
  Percent51 = '51%',
  Percent97 = '97%',
}
export enum SteelStructural {
  None = 'None',
  Percent100 = '100%',
}

export enum MetalProducts {
  AluminumProfileNone = 'boverket_sv-SE_6000000159',
  AluminumProfilePercent100 = 'boverket_sv-SE_6000000160',
  AluminumSheet = 'boverket_sv-SE_6000000161',
  CopperPipePercent51 = 'boverket_sv-SE_6000000164',
  CopperPipePercent100 = 'boverket_sv-SE_6000000165',
  CopperSheetPercent51 = 'boverket_sv-SE_6000000162',
  CopperSheetPercent97 = 'boverket_sv-SE_6000000163',
  CopperWire = 'boverket_sv-SE_6000000166',
  SteelFastenersAndFitting = 'boverket_sv-SE_6000000191',
  SteelLightWeightProfile = 'boverket_sv-SE_6000000152',
  SteelPipeStainless = 'boverket_sv-SE_6000000157',
  SteelRebar = 'boverket_sv-SE_6000000154',
  SteelRebarStainless = 'boverket_sv-SE_6000000156',
  SteelSheet = 'boverket_sv-SE_6000000153',
  SteelSheetStainless = 'boverket_sv-SE_6000000158',
  SteelStructuralNone = 'boverket_sv-SE_6000000150',
  SteelStructuralPercent100 = 'boverket_sv-SE_6000000151',
  SteelWire = 'boverket_sv-SE_6000000155',
}
